import { cacheExchange, Client, fetchExchange } from '@urql/core';

export default {
    data() {
        return {
            GraphQlClient: null,
        };
    },
    methods: {
        createGraphQlClient(url, headers = {}) {
            this.GraphQlClient = new Client({
                url,
                preferGetMethod: false,
                exchanges: [cacheExchange, fetchExchange],
                fetchOptions: () => ({ headers }),
            });
        },
        async graphQlQuery(query, variables) {
            if (this.GraphQlClient === null) {
                const err = 'GraphQlClient: Not initialized';
                throw err;
            }

            const result = await this.GraphQlClient.query(query, variables);

            if (result.error) {
                throw result.error;
            }

            return result.data;
        },
    },
};
